import { v2ParamsSerializer } from '@stuut/common/src/api_client';
import { ModelResource } from './resource';
import { CreditMemo } from '../models';

export interface CreditMemoSearchParams {
  query?: string;
  limit?: number;
  page?: number;
  amount?: number;
  currency?: string;
  status__in?: string[];
  partner_ids__in?: string[];
  min_score?: number;
}

export interface CreditMemoSearchResult {
  creditMemo: CreditMemo;
  score: number;
  match_type: 'exact' | 'fuzzy' | null;
  matched_field: string | null;
  matched_value: string | null;
}

export interface CreditMemoSearchResponse {
  data: CreditMemoSearchResult[];
  total_records: number;
  current_page: number;
  next_page: number | null;
}

export class CreditMemos extends ModelResource<CreditMemo> {
  model = CreditMemo;

  resourcePath = 'v1/credit-memos';

  async sync(creditMemo: CreditMemo): Promise<CreditMemo> {
    const res = await this.api.post(this.path(creditMemo.id, 'sync'));

    creditMemo.updateFromJson(res.data);

    return creditMemo;
  }

  /**
   * Search credit memos using v2 API with Decimal amount support.
   * Amount is in standard units (e.g., 10.25 for $10.25 USD).
   */
  async search(params: CreditMemoSearchParams): Promise<CreditMemoSearchResponse> {
    const res = await this.api.get('v2/credit-memos/search', {
      params,
      paramsSerializer: v2ParamsSerializer,
    });

    // Deserialize credit memos in data
    const data = res.data.data.map((result: any) => ({
      ...result,
      creditMemo: this.model.fromJson(result.credit_memo) as CreditMemo,
    }));

    return {
      ...res.data,
      data,
    };
  }
}
